// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__PIBB5","admin__body":"Admin_admin__body__PTD8v","title":"Admin_title__chehX","input":"Admin_input__biupL","submit":"Admin_submit__xNsV2"};